import React, { FC } from 'react';
import { Container, ContentLoader, LoaderWrapper, Tabs, Tab } from './styles';

const Loader: FC = () => {
  return (
    <Container>
      <Tabs>
        <Tab label="Order" to="" />
        <Tab label="Customer" exact to="" />
        {/* <Tab label="Courier" exact to="" /> */}
      </Tabs>
      <LoaderWrapper>
        <ContentLoader
          viewBox="0 0 290 45"
          backgroundColor="#f1f1f1"
          opacity={1}
        >
          <circle cx="20" cy="20" r="15" />
          <rect x="53" y="12" rx="7" ry="7" width="110" height="15" />
        </ContentLoader>
        <ContentLoader
          viewBox="0 0 290 45"
          backgroundColor="#f1f1f1"
          opacity={0.75}
        >
          <circle cx="20" cy="20" r="15" />
          <rect x="53" y="12" rx="7" ry="7" width="110" height="15" />
        </ContentLoader>
        <ContentLoader
          viewBox="0 0 290 45"
          backgroundColor="#f1f1f1"
          opacity={0.5}
        >
          <circle cx="20" cy="20" r="15" />
          <rect x="53" y="12" rx="7" ry="7" width="110" height="15" />
        </ContentLoader>
        <ContentLoader
          viewBox="0 0 290 45"
          backgroundColor="#f1f1f1"
          opacity={0.25}
        >
          <circle cx="20" cy="20" r="15" />
          <rect x="53" y="12" rx="7" ry="7" width="110" height="15" />
        </ContentLoader>
        <ContentLoader
          viewBox="0 0 290 45"
          backgroundColor="#f1f1f1"
          opacity={0}
        >
          <circle cx="20" cy="20" r="15" />
          <rect x="53" y="12" rx="7" ry="7" width="110" height="15" />
        </ContentLoader>
      </LoaderWrapper>
    </Container>
  );
};

export default Loader;
